import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Chart, LinearTickOptions } from 'chart.js';
import { fetchApi } from '../services/api';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>

type State = {
    ChartLabels: string[];
    ChartData: number[];
}

export default class Home extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            ChartLabels: [],
            ChartData: [],
        }
    }

    public componentDidMount() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID")
        }
        fetchApi('api/Children/WeeklyChart', data, 'POST')
            .then((data: Array<{ Label: string, Value: number }>) => {
                this.setState({
                    ChartLabels: data.map(x => x.Label),
                    ChartData: data.map(x => x.Value)
                }, () => {
                    this.buildChart();
                });
            })
    }

    public render() {
        return <React.Fragment>
                <DocumentTitle title="Dashboard" />
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
                    <h1 className="h2">New Children Registered</h1>
                    <div className="btn-toolbar mb-2 mb-md-0">
                    <div className="btn-group mr-2">
                        <button className="btn btn-sm btn-outline-secondary">Export</button>
                    </div>
                    <button className="btn btn-sm btn-outline-secondary dropdown-toggle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-calendar">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        This week
                    </button>
                    </div>
                </div>
                <canvas className="my-4" id="signup-chart" width="900" height="380"></canvas>
            </React.Fragment>;
    }

    private buildChart() {
        const ctx = document.getElementById('signup-chart') as HTMLCanvasElement;
        var myChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: this.state.ChartLabels,
              datasets: [{
                data: this.state.ChartData,
                lineTension: 0,
                backgroundColor: 'transparent',
                borderColor: '#007bff',
                borderWidth: 4,
                pointBackgroundColor: '#007bff'
              }]
            },
            options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    } as LinearTickOptions
                }]
                },
                legend: {
                    display: false,
                }
            }
          });
    }
}
